/**
 * make new schema title while should not be the same of any existing ones
 */
export const makeTitle = ({
  titles,
  title,
  count = 0,
}: {
  titles: string[];
  title: string;
  count?: number;
}) => {
  if (count === 0 && title.search(/\s\(\d\)$/) >= 0) {
    count = parseInt((title.match(/\s\((\d)\)$/) || [])[1]);
    title = title.replace(/\s\(\d\)$/, "");
  }

  const new_title = count === 0 ? title : title + " (" + count + ")";

  return titles.includes(new_title)
    ? makeTitle({ titles, title, count: ++count })
    : new_title;
};
